module.exports = __webpack_public_path__ + "static/img/5-1-3.688b1a20.jpg";